import { GetterTree } from "vuex";
import { State } from "./state";

export default {
    newsAnnouncement: (state: State) => state.newsAnnouncement,
    newsAnnouncementInit: (state: State) => state.newsAnnouncementInit,
    newsAnnouncements: (state: State) => state.newsAnnouncements,
    newsAnnouncementCount: (state: State) => state.newsAnnouncementCount
} as GetterTree<State, any>;